<template>
  <div class="giftcode-detail">
    <div class="game-page">
      <div class="game-page__header">
        <v-container>
          <div v-if="status.loading_game">
            <v-skeleton-loader
              tile
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
          </div>
          <div v-else>
            <div class="item">
              <div class="item__image">
                <img :src="gameById.icon" alt="" srcset="" />
              </div>
              <div class="item__content">
                <div class="item__title">{{ gameById.name }}</div>
                <div class="item__type">{{ gameById.type }}</div>
              </div>
              <div
                @click="downloadGame(gameById)"
                class="item__button"
                style="cursor: pointer"
              >
                <img src="../assets/icons/down.svg" alt="" srcset="" />
              </div>
            </div>
          </div>
        </v-container>
      </div>
    </div>
    <div class="giftcode-detail__content">
      <v-container>
        <div class="home-item">
          <v-row>
            <v-col cols="6" class="text-center">
              <v-btn
                class="home-item__btn"
                @click="homePage(gameById)"
                depressed
                outlined
                large
                width="100%"
                color="#e88d50"
              >
                <div class="home-item__text" color="#e88d50">
                  <img src="../assets/icons/home.svg" alt="" srcset="" />
                  <span class="white--text">Trang chủ</span>
                </div>
              </v-btn>
            </v-col>
            <v-col cols="6" class="text-center">
              <v-btn
                class="home-item__btn facebook"
                @click="goFanpage(gameById)"
                depressed
                outlined
                large
                width="100%"
                color="#e88d50"
              >
                <div class="home-item__text" color="#e88d50">
                  <img src="../assets/icons/facebook.svg" alt="" srcset="" />
                  <span class="white--text">Fanpage</span>
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <v-card class="giftcode-card" outlined>
          <Recieved
            :zalo_contact="gameById.admin_zalo"
            :game_alias="gameById.alias"
          />
        </v-card>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Buttons } from '../services/functions'
import Recieved from '../components/Recieved'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'GiftcodeDetail',
  components: { Recieved },
  data: () => {
    return {
      tab: 'all',
    }
  },
  created() {
    this.$store.dispatch('GAME_BY_ID', {
      game_id: localStorage.getItem('game_id'),
    })
  },
  computed: {
    ...mapGetters([
      'GAME_BY_ID',
      'GIFTCODE_GENERIC',
      'GIFTCODE_UNIQUE',
      'isAuthenticated',
    ]),
    ...mapState(['status']),
    gameById() {
      return this.$store.getters.GAME_BY_ID
    },
  },
  methods: {
    homePage: Buttons.homePage,
    goFanpage: Buttons.goFanpage,
    downloadGame: Buttons.downloadGame,
  },
}
</script>

<style lang="scss">
.v-dialog__content.v-dialog__content--active {
  .v-dialog.v-dialog--active.v-bottom-sheet {
    margin-bottom: 150px !important;
    border-radius: 15px !important;
  }
}
</style>
